import React from 'react';
import { Breadcrumbs, Typography } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { DiamDetailsFields, DiamDetailsTextField } from '../DiamDetailsFields';
import { Identity } from '../IdentitiesGrid/types';
import { IDENTITIES_PATH } from './constants';
import { BreadcrumbLink, BreadcrumbsWrap, SectionTitle } from './styles';

interface IdentityInfoPanelProps {
  identity: Identity;
}

export function IdentityInfoPanel({ identity }: IdentityInfoPanelProps) {
  return (
    <>
      <BreadcrumbsWrap>
        <Breadcrumbs
          separator={<NavigateNextIcon color="action" fontSize="small" />}
        >
          <BreadcrumbLink to={IDENTITIES_PATH}>Identities</BreadcrumbLink>
          <Typography color="textPrimary" variant="body1">
            {identity.name}
          </Typography>
        </Breadcrumbs>
      </BreadcrumbsWrap>
      <SectionTitle color="textPrimary" variant="h6">
        User Details
      </SectionTitle>
      <DiamDetailsFields>
        <DiamDetailsTextField title="Name" value={identity.name} />
        <DiamDetailsTextField title="Email Address" value={identity.email} />
        <DiamDetailsTextField
          title="Teams"
          value={
            identity.teams.length > 0 ? identity.teams.join(', ') : undefined
          }
        />
        <DiamDetailsTextField
          title="Phone Number"
          value={identity.phoneNumber}
        />
      </DiamDetailsFields>
    </>
  );
}
